import React from "react"

import BackgroundImage from "../../../common/BackgroundImage"
import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"
import ShortTextWithReadMore from "../../../common/ShortTextWithReadMore"

const InsightAreaViewItemDetails = ({
    name,
    description,
    type,
    status,
    imageUrl,
    isFetching
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <span className="icon icon-headline" />Name
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLineLength={30}
                maxLineLength={70}
            >
                <p>{name || "No name"}</p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-insights" />Type
            </h3>
            <ContentLoaderLines isFetching={isFetching} lineLength={30}>
                <p>{type || "No type"}</p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-status" />Status
            </h3>
            <ContentLoaderLines isFetching={isFetching} lineLength={30}>
                <p>{status || "No status"}</p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-description" />Description
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLines={2}
                maxLines={5}
            >
                <ShortTextWithReadMore text={description || "No description"} />
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-heroimg" />Hero image
            </h3>
            <BackgroundImage
                classList={["item-background-image"]}
                imageUrl={imageUrl}
            />
        </div>
    </div>
)

export default InsightAreaViewItemDetails
